import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Role, RoleName, RoleService } from '@/services/role.service';

/** Erlaubt die Route, wenn der Benutzer mindestens eine der Rollen hat, sonst Weiterleitung auf "Kein Zugriff". */
export const roleGuard =
    (...roles: RoleName[]): CanActivateFn =>
    () =>
        inject(RoleService).hasAnyRole(roles) || inject(Router).createUrlTree(['/access-denied']);

/** Startseiten in Menue-Reihenfolge, falls das Dashboard nicht erlaubt ist. */
const START_PAGES: [RoleName, string][] = [
    [Role.BaseAccessMember, '/members/overview'],
    [Role.BaseAccessFinance, '/finance/cockpit'],
    [Role.BaseAccessJob, '/jobs/overview'],
    [Role.ProcessModification, '/modifications/overview']
];

/** Dashboard als Startseite; ohne Dashboard-Rolle auf die erste erlaubte Seite weiterleiten. */
export const dashboardGuard: CanActivateFn = () => {
    const roleService = inject(RoleService);
    if (roleService.hasRole(Role.BaseAccessDashboard)) return true;
    const startPage = START_PAGES.find(([role]) => roleService.hasRole(role));
    return inject(Router).createUrlTree([startPage?.[1] ?? '/access-denied']);
};
